import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAuthy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_29576_6795)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M24 11.9963C23.9961 15.1768 22.731 18.2258 20.4821 20.4747C18.2332 22.7237 15.1841 23.9888 12.0037 23.9927C8.82196 23.9907 5.77101 22.7265 3.52052 20.4773C1.27003 18.2282 0.00387954 15.178 0 11.9963C0.00387622 8.8159 1.26902 5.76684 3.51793 3.51793C5.76684 1.26902 8.8159 0.00387622 11.9963 0C15.1768 0.00387622 18.2258 1.26902 20.4748 3.51793C22.7237 5.76684 23.9961 8.8159 24 11.9963Z",
				fill: "#EC1C24"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M10.9708 9.44762L13.8491 12.3259C14.2665 12.7433 14.9476 12.7433 15.3578 12.3259C15.7679 11.9084 15.7752 11.2273 15.3578 10.8172L12.4795 7.93893C10.4142 5.89559 7.08922 5.85898 4.97997 7.83639L4.87011 7.93893C2.8341 10.0994 2.8634 13.4318 4.92138 15.4824L7.79962 18.3607C8.21708 18.7781 8.89819 18.7781 9.30832 18.3607C9.71845 17.9432 9.72577 17.2621 9.30832 16.852L6.44472 13.9884C5.19968 12.7433 5.17771 10.6927 6.41543 9.42565C7.65315 8.15864 9.71113 8.19526 10.9708 9.45495V9.44762ZM14.684 5.61729C14.2665 6.03475 14.2665 6.71586 14.684 7.12599L17.5622 10.0042C18.8073 11.2493 18.8292 13.2999 17.5842 14.5669C16.3391 15.834 14.2885 15.7973 13.0288 14.5376L10.1506 11.6594C9.7331 11.2419 9.05199 11.2419 8.64185 11.6594C8.23172 12.0769 8.2244 12.758 8.64185 13.1681L11.5201 16.0463C13.5708 18.097 16.9031 18.1409 19.0123 16.1489L19.1222 16.0463C21.1582 13.8858 21.1289 10.5535 19.0709 8.50286L16.1853 5.62461C15.7679 5.20716 15.0868 5.20716 14.6766 5.62461L14.684 5.61729Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_29576_6795",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAuthy);
export { ForwardRef as ReactComponent };
